<div class="main-container">
  <app-embedded-loader [show]="showLoader"></app-embedded-loader>

  <app-buyer-supplier-chat
    [headerData]="headerData"
    [isOpen]="isChatOpen"
    [rfqId]="headerData?.rfqId"
    [userId]="userIdAsString"
    [isSupplier]="userRole === 'Suppliers'"
    (close)="closeChat()"
  ></app-buyer-supplier-chat>

  <div class="title-text">Request For Quotation</div>
  <div class="section">
    <div class="search-filter-container">
      <div class="search-container">
        <input
          type="text"
          [(ngModel)]="searchParam"
          placeholder="Search on RFQ number,Supplier Name and Keywords"
          class="search-input"
        />
        <button class="search-button" (click)="onSearch()">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>
      <div class="search-filter-content">
        <mat-form-field class="date-field" appearance="fill">
          <mat-label>From Date</mat-label>
          <input
            matInput
            [matDatepicker]="fromDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="fromDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #fromDatepicker></mat-datepicker>

        <mat-form-field class="date-field" appearance="fill">
          <mat-label>To Date</mat-label>
          <input
            matInput
            [matDatepicker]="toDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="toDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #toDatepicker></mat-datepicker>
        <div class="search-filter-button-container">
          <button type="submit" class="search-btn" (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button type="button" class="close-button" (click)="cancelFilter()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="filter-statuses">
      <button
        *ngFor="let status of filterStatuses; let i = index"
        class="status-btn"
        [ngClass]="{ active: activeIndex === i }"
        (click)="onStatusSelect(status.name, i, status.label)"
        matTooltip="{{ status.label }}"
      >
        {{ status.name }}
      </button>

      <!-- RFQ Type Switcher Dropdown -->
      <div class="rfq-type-dropdown" style="margin-left: auto;">
        <button class="status-btn rfq-type-btn" [ngClass]="{ active: true }" (click)="toggleRfqTypeDropdown()">
          Product RFQ <mat-icon style="font-size: 18px; height: 18px; width: 18px; vertical-align: middle;">arrow_drop_down</mat-icon>
        </button>
        <div class="dropdown-menu rfq-type-menu" *ngIf="rfqTypeDropdownOpen">
          <button class="dropdown-item active-item" (click)="toggleRfqTypeDropdown()">
            Product RFQ
          </button>
          <button class="dropdown-item" (click)="navigateToRfqType('service'); toggleRfqTypeDropdown()">
            Service RFQ
          </button>
        </div>
      </div>
    </div>

    <div
      class="filter-section"
      style="display: flex; align-items: center"
      *ngIf="this.selectedRfq.length > 0"
    >
      <div style="margin-left: 20px">
        <b
          >Selected {{ this.selectedRfq.length }} of
          {{ this.totalRecords }} RFQs</b
        >
      </div>

      <button
        style="position: relative; bottom: 3px"
        mat-icon-button
        mat-sm-button
        color="primary"
        class="mr-1"
        matTooltipClass="mat-tooltip-custom"
        matTooltip="Archive"
        matTooltipPosition="below"
        (click)="rfqOperation('archive')"
      >
        <mat-icon>archive</mat-icon>
      </button>
    </div>

    <div class="dropdown-container-active">
      <div class="text-right" style="display: inline-flex; align-items: center">
        <button
          mat-mini-fab
          matTooltip="Export All"
          matTooltipPosition="below"
          (click)="exportAllRfqs()"
        >
          <mat-icon
            matTooltipClass="mat-tooltip-custom"
            svgIcon="downloadExcel"
          ></mat-icon>
        </button>
        <!-- <span style="font-size: 16px;font-weight: bolder;margin-left:5px">Export All</span> -->
      </div>
      <div
        style="
          width: 7%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="invitebutton-container">
          <!-- Button to trigger the user invite menu -->
          <button
            class="circle-button"
            [matMenuTriggerFor]="usermenu"
            matTooltip="Invite User"
            (click)="onUserMenuOpened()"
          >
            <mat-icon class="icon-person"> person_add </mat-icon>
          </button>

          <!-- Menu for inviting users with fixed height and scrollable -->
          <mat-menu #usermenu="matMenu" id="usermenu">
            <!-- Menu content container with scroll event -->
            <div class="menu-content" (scroll)="onScroll()">
              <!-- User list displayed inside the menu with checkboxes for selection -->
              <button
                mat-menu-item
                *ngFor="let item of buyerUsersList"
                (click)="toggleUserSelection(item)"
              >
                <mat-checkbox [checked]="item.selected">{{
                  item.firstName
                }}</mat-checkbox>
              </button>

              <!-- Spinner or loading indicator when fetching more users -->
              <mat-progress-spinner
                *ngIf="isLoading"
                mode="indeterminate"
                diameter="20"
              ></mat-progress-spinner>
            </div>
          </mat-menu>
        </div>
        <div>
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="menu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of items"
              (click)="toggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="active-table-container">
      <ngx-datatable
        style="border-radius: 5px"
        #supplierTable
        class="material expandable bg-light supplier-table sup-tbl"
        [rows]="documentData"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
        [limit]="limit"
        [count]="totalRecords"
        [externalPaging]="true"
        [externalSorting]="true"
        [scrollbarH]="false"
        [offset]="offset"
        (page)="onPageChange($event)"
        (sort)="onSort($event)"
        [rowClass]="setRowClass"
      >
        <!-- select rfq -->
        <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="55"
          [minWidth]="55"
        >
          <ng-template ngx-datatable-header-template>
            <input
              type="checkbox"
              [checked]="this.selectedRfq.length == this.documentData.length"
              (change)="toggleSelectAll($event, 'active')"
            />
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <!-- <input type="checkbox" [checked]="isChecked(row.rfqId,'active')"
                        (change)="selectDeselectRfq($event, row.rfqId,'active',row.owner)" /> -->
            <input
              type="checkbox"
              [checked]="isChecked(row.rfqId, 'active')"
              (change)="
                selectDeselectRfq(
                  $event,
                  row.rfqDetailsId,
                  row.rfqId,
                  'active',
                  row.buyerUserName
                )
              "
            />
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Reference" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="rfq-reference"
              matTooltip="{{ row.rfqRefNumber }}"
              matTooltipPosition="below"
              (click)="openRfqDetails(row.rfqDetailsId)"
              >{{ row.rfqRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- vessel Name -->
        <ngx-datatable-column name="Vessel" [flexGrow]="0.6">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Vessel"
              matTooltip="{{ row.vesselName }}"
              matTooltipPosition="below"
              >{{ row.vesselName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Port Name" [flexGrow]="0.7">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Port Name"
              matTooltip="{{ row.portName }}"
              matTooltipPosition="below"
              >{{ row.portName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Total Suppliers" [flexGrow]="0"
        [minWidth]="100"
        [maxWidth]="120">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{ row.suppliers?.length || 0 }}</span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Status -->
        <ngx-datatable-column name="Status" [flexGrow]="0"
        [minWidth]="100"
        [maxWidth]="120">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="status-pill"
              matTooltip="{{
                row.docStatus === 'Unactioned' ? 'Submitted' : row.docStatus
              }}"
              matTooltipPosition="below"
              [ngStyle]="{ color: getStatusColor(row.docStatus) }"
            >
              {{ row.docStatus === "Unactioned" ? "Submitted" : row.docStatus }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Quote Before Date" [flexGrow]="0.8">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Quote Before Date"
              matTooltip="{{ getRemainingTimeForQuoteDate(row).tooltip }}"
              matTooltipPosition="below"
            >
              {{ row.quotedByDate | date : "dd/MM/yyyy" }}
            </span>
            <span
              [ngStyle]="{ color: getRemainingTimeForQuoteDate(row).color }"
              style="display: block"
            >
              {{ getRemainingTimeForQuoteDate(row).tooltip }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="RFQ Created Date Time span" [flexGrow]="0"
        [minWidth]="100"
        [maxWidth]="120">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="RFQ Date"
              matTooltip="{{ row.rfqDate | date : 'dd/MM/yyyy' }}"
              matTooltipPosition="below"
            >
              {{ formatRfqDate(row.rfqDate) }}
            </span>
            <span
              [ngStyle]="{ color: getRemainingTime(row).color }"
              style="display: block"
            >
              {{ getRemainingTime(row).label }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
        name="ATT/Print/Download"
        [resizeable]="true"
        [sortable]="false"
        [flexGrow]="0"
        [minWidth]="170"
        [maxWidth]="200"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="action-buttons-container">
            <button
              mat-icon-button
              color="primary"
              matTooltip="Attachments"
              matTooltipPosition="below"
              (click)="togglePreview(true, 'rfq', row)"
            >
              <mat-icon>attach_file</mat-icon>
            </button>
      
      
            <span
            [matTooltip]="
               row.docStatus === 'Draft'
                ? 'Printing is disabled for Draft RFQ.'
                : 'Print'
            "
            matTooltipPosition="below"
          >
            <button
              mat-icon-button
              color="primary"
              [disabled]="row.docStatus === 'Draft'"
              (click)="downloadRfqForBuyer(row.rfqRefNumber, row)"
            >
              <mat-icon>print</mat-icon>
            </button>
          </span>

          <span
            [matTooltip]="
               row.docStatus === 'Draft'
                ? 'Download is disabled for Draft RFQ.'
                : 'Download'
            "
            matTooltipPosition="below"
          >
            <button
              mat-icon-button
              color="primary"
              [disabled]="row.docStatus === 'Draft'"
              (click)="generateRFQExcelForBuyer(row.rfqId)"
            >
              <mat-icon>download</mat-icon>
            </button>
          </span>

            
          </div>
        </ng-template>
      </ngx-datatable-column>

        <!-- <ngx-datatable-column *ngFor="let column of selectedColumns" [name]="column.label" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="isDate(row[column.prop])" matTooltip="{{ row[column.prop] | date:'dd/MM/yyyy' || '-' }}" matTooltipPosition="below">
                    {{ row[column.prop] | date:'dd/MM/yyyy' || '-' }}
                    </span>
                    <span *ngIf="!isDate(row[column.prop])" matTooltip="{{ row[column.prop] || '-' }}" matTooltipPosition="below">
                    {{ row[column.prop] || '-' }}
                    </span>
                </ng-template>
            </ngx-datatable-column> -->


        <ngx-datatable-column
          *ngFor="let column of selectedColumns"
          [name]="column.label"
          [flexGrow]="1"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            
            <!-- Special handling for "Owner" column -->
            <ng-container *ngIf="column.label === 'Owner'; else normalCell">
              <span
                matTooltip="{{ row.buyerUserName ? row.buyerUserName : row.buyerName }}"
                matTooltipPosition="below"
              >
                {{ row.buyerUserName || row.buyerName }}
              </span>
            </ng-container>

            <!-- Default rendering for all other columns -->
            <ng-template #normalCell>
              <span
                *ngIf="isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}
              </span>
              <span
                *ngIf="!isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] || '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] || '-' }}
              </span>
            </ng-template>

          </ng-template>
        </ngx-datatable-column>


        <!-- Toggle Expand Button Column -->
        <ngx-datatable-column
          name="Track Status"
          [sortable]="false"
          [maxWidth]="69"
          [minWidth]="45"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <mat-icon
              class="live-status-button"
              (click)="toggleExpandedRow(row)"
              matTooltip="Live status"
            >
              {{ expandedRowId === row.id ? "expand_less" : "expand_more" }}
            </mat-icon>
            <div
              [style.height.px]="
                row.suppliers.length === 0
                  ? 266
                  : row.suppliers.length > 3
                  ? 480
                  : row.suppliers.length * 120 + 266
              "
              style="width: 1px"
              *ngIf="expandedRowId === row.id"
            ></div>

            <div
              class="status-tracker-main-container"
              *ngIf="expandedRowId === row.id"
            >
              <div class="expanded-status-row">
                <div class="status-timeline-container">
                  <!-- <div class="timeline-box-header">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div class="timeline-stage-header">
                        <div class="stage-header-up">
                          <span class="stage-heading">{{ stage.heading }}</span>
                          <span class="stage-date">{{ stage.date }}</span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="timeline-box">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div class="timeline-stage">
                        <div class="stage-header">
                          <span class="stage-label">{{ stage.label }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-box-footer">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages; let i = index"
                    >
                      <div class="timeline-stage-footer">
                        <div
                          class="stage-point"
                          [ngClass]="[
                            getStageColorClass(stage.label, row),
                            'animate-point',
                            getCompleteIncompleteClass(stage)
                          ]"
                          [style.animationDelay]="i * 1.2 + 's'"
                        ></div>
                        <div
                          *ngIf="i < row.statusesStages.length - 1"
                          class="timeline-line animate-line"
                          [ngClass]="[
                            getStageColorClass(stage.label, row),
                            getCompleteIncompleteClass(stage)
                          ]"
                          [style.animationDelay]="i * 1.2 + 0.6 + 's'"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-box-header">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages; let i = index"
                    >
                      <div class="timeline-stage-header">
                        <div
                          class="stage-header-up"
                          [ngClass]="['animate-point']"
                          [style.animationDelay]="i * 1.2 + 's'"
                        >
                          <!-- <span class="stage-heading">{{ stage.heading }}</span> -->
                          <span class="stage-date">{{ stage.date }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Implement here the table -->
                  <!-- RFQ Supplier Table -->
                  <!-- Top-right action buttons -->
                  <div
                    class="arrow-text alert alert-danger"
                    style="width: 870px; margin-top: 14px; margin-left: 6px"
                    *ngIf="row?.suppliers?.length === 0"
                  >
                    No suppliers found
                  </div>
                  <div class="table-actions" *ngIf="row?.suppliers?.length > 0">
                    <button
                      class="chip-btn"
                      (click)="onReminderClick(row)"
                      [disabled]="selectedSupplierForReminders.length === 0"
                    >
                      Reminder {{ selectedSupplierForReminders.length }}/{{
                        row?.suppliers?.length || 0
                      }}
                    </button>

                    <button
                      class="chip-btn"
                      (click)="onCompareClick()"
                      [disabled]="
                        selectedSuppliersQuotationForCompare.length < 2
                      "
                    >
                      Compare
                      {{ selectedSuppliersQuotationForCompare.length }}/{{
                        row?.suppliers?.length || 0
                      }}
                    </button>

                    <button
                      class="add-btn"
                      [matMenuTriggerFor]="columnMenu"
                      aria-label="Add"
                    >
                      <mat-icon>add</mat-icon>
                    </button>

                    <mat-menu #columnMenu="matMenu">
                      <div *ngFor="let col of columnOptions">
                        <mat-checkbox [(ngModel)]="col.visible">
                          {{ col.label }}
                        </mat-checkbox>
                      </div>
                    </mat-menu>
                  </div>

                  <div
                    class="supplier-table-container"
                    *ngIf="row?.suppliers?.length > 0"
                  >
                    <table class="supplier-table">
                      <thead>
                        <tr style="background-color: #44796f">
                          <th style="width: 63px">
                            <mat-checkbox
                              [(ngModel)]="masterSelected"
                              (change)="selectAllSuppliers(row.suppliers, row)"
                            ></mat-checkbox>
                          </th>
                          <th>Supplier Name</th>
                          <th>Quoted Items</th>
                          <th>
                            <span
                              >Total Requested Cost
                              <span
                                ><mat-slide-toggle
                                  (change)="toggleWrapDescription($event, row)"
                                  [checked]="isWrapDescription"
                                ></mat-slide-toggle></span
                            ></span>
                            <span
                              style="
                                position: relative;
                                left: 104px;
                                top: 9px;
                                cursor: pointer;
                              "
                              [matMenuTriggerFor]="infoMenu"
                              ><mat-icon>info</mat-icon></span
                            >
                            <mat-menu #infoMenu="matMenu" class="custom-menu">
                              <div
                                style="
                                  padding: 8px;
                                  max-width: 250px;
                                  white-space: normal;
                                "
                              >
                                <p
                                  style="
                                    margin: 0;
                                    font-size: 13px;
                                    line-height: 1.4;
                                  "
                                >
                                  Currency conversion is powered by
                                  ExchangeRate-API and locked at entry.
                                </p>
                                <a
                                  href="https://www.exchangerate-api.com/"
                                  target="_blank"
                                  class="tooltip-link"
                                >
                                  Click here ↗
                                </a>
                                to check prices in your preferred currency.
                              </div>
                            </mat-menu>
                          </th>
                          <th>Payment Terms</th>
                          <th>Response Time</th>
                          <th>Status</th>
                          <!-- Extra dynamic headers -->
                          <th
                            *ngFor="let col of columnOptions"
                            [hidden]="!col.visible"
                          >
                            {{ col.label }}
                          </th>

                          <th>Action</th>

                          <th>Ask any Questions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let supplier of row.suppliers">
                          <td>
                            <mat-checkbox
                              [(ngModel)]="supplier.selected"
                              (change)="checkIfAllSelected(row.suppliers, row)"
                            ></mat-checkbox>
                          </td>
                          <!-- Supplier Name -->
                          <td>
                            <span class="supplier-name">{{
                              supplier.supplierName || "N/A"
                            }}</span>
                          </td>

                          <!-- Quoted Items -->
                          <td>{{ supplier.quotedItems || "N/A" }}</td>

                          <!-- Total Requested Cost -->
                          <td>
                            {{
                              getConvertedAmount(
                                supplier,
                                row.rfqReqCurrencyCode
                              )
                            }}
                          </td>

                          <!-- Payment Terms -->
                          <td>
                            {{ supplier.paymentTermsAndConditions || "N/A" }}
                          </td>

                          <!-- Response Time -->
                          <td>
                            {{
                              supplier.responseTime
                                ? formatDate(supplier.responseTime)
                                : "N/A"
                            }}
                          </td>

                          <!-- Status -->
                          <td>
                            <!-- <ng-container *ngIf="supplier.rfqStatus!=null && supplier.quoteId!=null">
                              {{ rfqStatuses[supplier.rfqStatus - 1] || "N/A" }}
                            </ng-container>
                            <ng-container *ngIf="supplier.rfqStatus==null || supplier.quoteId==null">
                              Unactioned
                            </ng-container> -->
                            <!-- <ng-container *ngIf="supplier.rfqStatus!=null || supplier.quoteId!=null">
                              {{ rfqStatuses[supplier.rfqStatus - 1] || "N/A" }}
                            </ng-container>
                            <ng-container *ngIf="supplier.rfqStatus==null && supplier.quoteId==null">
                              Unactioned
                            </ng-container> -->
                            
                            <ng-container *ngIf="supplier.quoteId != null; else checkRfqStatus">
                              {{ rfqStatuses[supplier.quoteStatus - 1]}}
                             </ng-container>

                            <ng-template #checkRfqStatus>
                              <ng-container *ngIf="supplier.rfqStatus != null; else showUnactioned">
                                {{ rfqStatuses[supplier.rfqStatus - 1] }}
                              </ng-container>
                            </ng-template>

                            <ng-template #showUnactioned>
                              Unactioned
                            </ng-template>
                          </td>
                          <!-- Extra dynamic columns -->
                          <td
                            *ngFor="let col of columnOptions"
                            [hidden]="!col.visible"
                          >
                            <ng-container [ngSwitch]="col.key">
                              <span *ngSwitchCase="'quotationDate'">
                                {{
                                  supplier.rfqStatus === 3
                                    ? formatDate(supplier.responseTime)
                                    : "N/A"
                                }}
                              </span>
                              <span *ngSwitchCase="'rating'">
                                {{ supplier.rating || "N/A" }}
                              </span>
                              <span *ngSwitchCase="'leadTime'">
                                {{ supplier.leadTime || "N/A" }}
                              </span>
                            </ng-container>
                          </td>

                          <!-- Action -->
                          <td>
                            <ng-container
                              [ngSwitch]="rfqStatuses[supplier.rfqStatus - 1]"
                            >
                              <button
                                *ngSwitchCase="'Quoted'"
                                mat-icon-button
                                color="primary"
                                matTooltip="View"
                                (click)="
                                  openQuoteDetails(
                                    row.rfqId,
                                    supplier.quoteId,
                                    supplier.supplierId
                                  )
                                "
                              >
                                <mat-icon>visibility</mat-icon>
                              </button>

                              <button
                              *ngSwitchCase="'Quoted'"
                              mat-icon-button
                              color="primary"
                              matTooltip="Attachments"
                              matTooltipPosition="below"
                              (click)="togglePreview(true,'quote', supplier)"
                            >
                              <mat-icon>attach_file</mat-icon>
                            </button>
                      
                            <button
                            *ngSwitchCase="'Quoted'"
                              mat-icon-button
                              color="primary"
                              matTooltip="Supplier contact Details"
                              matTooltipPosition="below"
                              (click)="toggleContactPopUp(true, supplier)"
                            >
                              <mat-icon>local_phone</mat-icon>
                            </button>
                      
                            <button
                            *ngSwitchCase="'Quoted'"
                              mat-icon-button
                              color="primary"
                              matTooltip="Print"
                              matTooltipPosition="below"
                              (click)="downloadQuote(row, supplier)"
                            >
                              <mat-icon>print</mat-icon>
                            </button>
                      
                            <button
                             *ngSwitchCase="'Quoted'"
                              mat-icon-button
                              color="primary"
                              matTooltip="Download"
                              matTooltipPosition="below"
                              (click)="generateQuoteExcel(supplier.quoteId, row.rfqId, supplier.supplierId, supplier.quoteId)"
                            >
                              <mat-icon>download</mat-icon>
                            </button>

                              <button
                                *ngSwitchCase="'Acknowledged'"
                                mat-raised-button
                                (click)="sendReminder(row, supplier)"
                                color="warn"
                              >
                                Send Reminder
                              </button>
                              <span *ngSwitchDefault>N/A</span>
                            </ng-container>
                          </td>

                          <!-- Clarifications -->
                          <td>
                            <button
                              mat-icon-button
                              matBadge="{{ supplier.questions }}"
                              matBadgeColor="primary"
                              (click)="openChat(row, supplier)"
                            >
                              <mat-icon>chat</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Action" [minWidth]="100" [flexGrow]="2">
          <ng-template let-column="column" ngx-datatable-header-template
            ><span>Action</span>
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button
              *ngIf="row.docStatus === 'Canceled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              matTooltip="Preview"
              matTooltipPosition="below"
              (click)="openRfqPreview(row.rfqDetailsId)"
            >
              <mat-icon>visibility</mat-icon>
            </button> 
            <!-- <button
              *ngIf="row.docStatus !== 'Canceled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="OpenRfq(row.rfqDetailsId)"
              matTooltip="Preview"
              matTooltipPosition="below"
            >
              <mat-icon>expand_more</mat-icon>
            </button> -->
            <!-- <button
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="OpenRfq(row.rfqDetailsId)"
              matTooltip="Preview"
              matTooltipPosition="below"
            >
              <mat-icon>visibility</mat-icon>
            </button> -->

            <button
              *ngIf="row.docStatus !== 'Canceled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="openRfqDetails(row.rfqId)"
              matTooltip="Open"
              matTooltipPosition="below"
            >
              <mat-icon>edit</mat-icon>
            </button>

            <button
              *ngIf="row.docStatus !== 'Canceled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="openCancellationBox(row.rfqId)"
              matTooltip="Cancel RFQ"
              matTooltipPosition="below"
            >
              <!-- <mat-icon class="color-red">cancel</mat-icon> -->
              <mat-icon color="warn" *ngIf="row.docStatus != 'Draft'">cancel</mat-icon>
               <mat-icon color="warn" *ngIf="row.docStatus === 'Draft'">delete</mat-icon>
            </button>

            <button
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1 chat-btn"
              [matBadge]="row.chatCount"
              [matBadgeHidden]="!row.chatCount"
              matBadgePosition="below after"
              matBadgeSize="small"
              matBadgeColor="primary"
              matTooltip="Chat"
              matTooltipPosition="below"
            >
              <mat-icon>chat</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

    <div class="archive-container" #heading>
      <span
        style="
          padding-left: 16px;
          padding-top: 16px;
          margin-bottom: 20px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;
        "
        (click)="toggleArchived()"
      >
        <div style="display: inline-flex; align-items: center">
          <span style="margin-left: 4px">Archived Documents</span>
        </div>

        <mat-icon>
          {{ isArchivedExpand ? "expand_less" : "expand_more" }}
        </mat-icon>
      </span>

      <ng-container *ngIf="isArchivedExpand">
        <div
          class="filter-section-selection-container"
          style="display: flex; align-items: center"
          *ngIf="this.selectedArchivedRfq.length > 0"
        >
          <div style="margin-left: 10px">
            <b
              >Selected {{ this.selectedArchivedRfq.length }} of
              {{ this.archivedTotalRecords }} archived RFQs</b
            >
          </div>

          <button
            style="position: relative; bottom: 3px"
            mat-icon-button
            mat-sm-button
            color="primary"
            class="mr-1"
            matTooltipClass="mat-tooltip-custom"
            matTooltip="Urchive"
            matTooltipPosition="below"
            (click)="rfqOperation('unarchive')"
          >
            <mat-icon>unarchive</mat-icon>
          </button>
        </div>

        <div class="dropdown-container">
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="archivedMenu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #archivedMenu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of archivedItems"
              (click)="archivedToggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>

        <ngx-datatable
          style="border-radius: 5px"
          #archivedSection
          #supplierTable
          class="material expandable bg-light supplier-table sup-tbl"
          [rows]="archivedDocumentData"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [columnMode]="'force'"
          [limit]="limit"
          [count]="archivedTotalRecords"
          [externalPaging]="true"
          [externalSorting]="true"
          [scrollbarH]="false"
          [offset]="archivedOffset"
          (page)="onArchivedPageChange($event)"
          (sort)="onSort($event)"
          [rowClass]="setRowClass"
        >
          <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="rfq-reference"
                matTooltip="{{ row.rfqRefNumber }}"
                matTooltipPosition="below"
                (click)="openRfqDetails(row.rfqDetailsId)"
                >{{ row.rfqRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>
          <!-- vessel Name -->
          <ngx-datatable-column name="Vessel" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Vessel"
                matTooltip="{{ row.vesselName }}"
                matTooltipPosition="below"
                >{{ row.vesselName }}</span
              >
            </ng-template>
          </ngx-datatable-column>
          <!-- Port Name -->
          <ngx-datatable-column name="Port Name" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Port Name"
                matTooltip="{{ row.portName }}"
                matTooltipPosition="below"
                >{{ row.portName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Total Suppliers" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span>{{ row.suppliers?.length || 0 }}</span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Status -->
          <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="status-pill"
                matTooltip="{{
                  row.docStatus === 'Unactioned' ? 'Submitted' : row.docStatus
                }}"
                matTooltipPosition="below"
                [ngStyle]="{ color: getStatusColor(row.docStatus) }"
              >
                {{
                  row.docStatus === "Unactioned" ? "Submitted" : row.docStatus
                }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="RFQ Created Date Time span"
            [flexGrow]="1"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="RFQ Date"
                matTooltip="{{ row.rfqDate | date : 'dd/MM/yyyy' }}"
                matTooltipPosition="below"
              >
                {{ formatRfqDate(row.rfqDate) }}
              </span>
              <span
                [ngStyle]="{ color: getRemainingTime(row).color }"
                style="display: block"
              >
                {{ getRemainingTime(row).label }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Quote Before Date" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- <span class="Quote Before Date" matTooltip="{{ getRemainingTimeForQuoteDate(row).tooltip }}" matTooltipPosition="below"> -->
              <span
                class="Quote Before Date"
                matTooltip="{{ getRemainingTimeForQuoteDate(row).tooltip }}"
                matTooltipPosition="below"
              >
                {{ row.quotedByDate | date : "dd/MM/yyyy" }}
              </span>
              <span
                [ngStyle]="{ color: getRemainingTimeForQuoteDate(row).color }"
                style="display: block"
              >
                {{ getRemainingTimeForQuoteDate(row).tooltip }}
              </span>
            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column
            *ngFor="let column of archivedSelectedColumns"
            [name]="column.label"
            [flexGrow]="1"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>

              <!-- Special handling for "Owner" column -->
              <ng-container *ngIf="column.label === 'Owner'; else archivedNormalCell">
                <span
                  matTooltip="{{ row.buyerUserName ? row.buyerUserName : row.buyerName }}"
                  matTooltipPosition="below"
                >
                  {{ row.buyerUserName || row.buyerName }}
                </span>
              </ng-container>

              <!-- Default rendering for all other columns -->
              <ng-template #archivedNormalCell>
                <span
                  *ngIf="isDate(row[column.prop])"
                  matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                  matTooltipPosition="below"
                >
                  {{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}
                </span>
                <span
                  *ngIf="!isDate(row[column.prop])"
                  matTooltip="{{ row[column.prop] || '-' }}"
                  matTooltipPosition="below"
                >
                  {{ row[column.prop] || '-' }}
                </span>
              </ng-template>

            </ng-template>
          </ngx-datatable-column>

          <!-- Restore Action -->

          <ngx-datatable-column name="Action" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <button
                class="popover_delete"
                [mdePopoverTriggerFor]="appPopover"
                mdePopoverTriggerOn="click"
                [mdePopoverBackdropCloseOnClick]="false"
                mat-icon-button
                #popoverTrigger="mdePopoverTrigger"
              >
                <mat-icon
                  matTooltipClass="mat-tooltip-custom"
                  matTooltip="Restore"
                  matTooltipPosition="below"
                  >restore</mat-icon
                >
              </button>

              <mde-popover
                #appPopover="mdePopover"
                [mdePopoverOverlapTrigger]="false"
              >
                <mat-card class="mat-card-popover popover-card">
                  <mat-card-header class="mat-card-header-popover">
                    <mat-card-title class="popover-title"
                      >Are you sure?</mat-card-title
                    >
                  </mat-card-header>
                  <mat-card-actions
                    class="mat-card-action-popover popover-actions"
                  >
                    <button
                      class="mat-action-btn popover_action cancel"
                      mat-raised-button
                      (click)="popoverTrigger.togglePopover()"
                    >
                      Cancel
                    </button>
                    <button
                      class="mat-action-btn popover_action restore"
                      mat-raised-button
                      color="warn"
                      (click)="RestoreRfq(true, row)"
                    >
                      Restore
                    </button>
                  </mat-card-actions>
                </mat-card>
              </mde-popover>
            </ng-template>
          </ngx-datatable-column>

          <!-- select rfq -->
          <!-- <ngx-datatable-column [sortable]="false" [maxWidth]="55" [minWidth]="55">
                        <ng-template ngx-datatable-header-template>
                            <input type="checkbox" [checked]="this.selectedRfq.length == this.documentData.length"
                                (change)="toggleSelectAll($event,'active')" />
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                
                            <input type="checkbox" [checked]="isChecked(row.rfqId,'active')"
                                (change)="selectDeselectRfq($event,row.supplierRfqDetailsId, row.rfqId,'active',row.supplierUserName)" />
                        </ng-template>
                    </ngx-datatable-column> -->
        </ngx-datatable>
      </ng-container>
    </div>

    <!-- Popup for confirmation -->

    <div class="namemodal" *ngIf="showConfirmationDialogue">
      <div class="modalContent">
        <div class="p-6 text-center">
          <div class="flex justify-center mb-4">
            <div
              class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
            >
              <mat-icon
                class="text-orange-600"
                style="font-size: 40px; height: 100%; width: 100%"
                >warning</mat-icon
              >
            </div>
          </div>
          <!-- <h2 class="text-xl font-bold mb-2">Are you sure?</h2> -->
          <!-- <p class="mb-6">
            Are you sure you want to cancel this request for quotation?<br />
            This action is permanent and can not be undon.<br />eSelect
            a reason from the dropdown
          </p> -->
          <p class="mb-6">
            Are you sure you want to 
            {{ selectedRfqStatus === 'Draft' ? 'delete' : 'cancel' }}
            this  {{ selectedRfqStatus === 'Draft' ? 'draft' : '' }} RFQ?<br />
            This action is permanent and can not be undone.<br />Select
            a reason from the dropdown
          </p>
          <mat-form-field class="full-width" color="accent">
            <mat-label> {{ selectedRfqStatus === 'Draft' ? 'Delete' : 'Cancel' }} reason</mat-label>
            <mat-select [(ngModel)]="cancelReason">
              <mat-option value="No Longer Needed">
                No Longer Needed</mat-option
              >
              <mat-option value="Duplicate RFQ"> Duplicate RFQ</mat-option>
              <mat-option value="Error in the RFQ Details">
                Error in the RFQ Details</mat-option
              >
              <mat-option value="Supplier Information not available">
                Supplier Information not available</mat-option
              >

              <mat-option value="Other"> Other</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Input field for custom reason when "Other" is selected -->
          <mat-form-field
            *ngIf="cancelReason === 'Other'"
            class="full-width"
            color="accent"
          >
            <mat-label>Specify the reason</mat-label>
            <input
              matInput
              [(ngModel)]="customReason"
              placeholder="Please specify"
            />
          </mat-form-field>
          <div class="flex justify-center gap-4">
            <button
              mat-raised-button
              color="primary"
              (click)="save(true)"
              [disabled]="
                cancelReason == '' ||
                (cancelReason === 'Other' && customReason.trim() === '')
              "
            >
              Yes, Cancel
            </button>
            <button mat-stroked-button (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-document-preview
  [previewDocs]="previewDocs"
  [showPopup]="previewSection"
  (close)="previewSection = false">
</app-document-preview>

<app-contact-details
  [showContactPopup]="showContactPopup"
  [contactData]="selectedSupplier"
  (close)="showContactPopup = false">
</app-contact-details>
